import { render, staticRenderFns } from "./DeliveryCard.vue?vue&type=template&id=234d7148&"
import script from "./DeliveryCard.vue?vue&type=script&lang=js&"
export * from "./DeliveryCard.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryCard.vue?vue&type=style&index=0&id=234d7148&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('234d7148')) {
      api.createRecord('234d7148', component.options)
    } else {
      api.reload('234d7148', component.options)
    }
    module.hot.accept("./DeliveryCard.vue?vue&type=template&id=234d7148&", function () {
      api.rerender('234d7148', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/sale/delivery-dashboard/components/DeliveryCard.vue"
export default component.exports